var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,5h30v20H0V5Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 12.6,
    r: 4.3,
    transform: "translate(-.128 .154) rotate(-.585)",
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M15,5.8c-.144,0-.2.217-.2.433,0,.522.064.795.2,1.567.136-.771.2-1.044.2-1.567,0-.216-.056-.433-.2-.433Z",
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a1",
    "data-name": "a",
    d: "M15.593,5.826c-.144-.013-.218.198-.237.414-.046.52-.006.798.063,1.578.203-.757.29-1.023.336-1.543.018-.216-.018-.437-.162-.449Z",
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a2",
    "data-name": "a",
    d: "M16.181,5.903c-.142-.025-.235.179-.272.392-.091.514-.075.794-.075,1.578.268-.736.378-.994.469-1.508.037-.214.02-.437-.122-.462Z",
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a3",
    "data-name": "a",
    d: "M16.76,6.032c-.14-.037-.249.158-.305.367-.135.504-.144.785-.212,1.565.331-.71.464-.957.599-1.462.055-.209.058-.433-.082-.47Z",
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a4",
    "data-name": "a",
    d: "M17.326,6.21c-.136-.049-.262.135-.336.339-.179.491-.212.769-.348,1.541.392-.678.545-.913.724-1.404.074-.204.095-.426-.04-.476Z",
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a5",
    "data-name": "a",
    d: "M17.874,6.437c-.131-.061-.273.112-.364.308-.221.473-.278.748-.481,1.504.449-.642.623-.862.843-1.335.091-.196.133-.416.002-.477Z",
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a6",
    "data-name": "a",
    d: "M18.4,6.711c-.125-.072-.282.088-.39.275-.261.452-.342.721-.61,1.457.503-.6.695-.805.957-1.257.108-.187.168-.403.043-.475Z",
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a7",
    "data-name": "a",
    d: "M18.9,7.03c-.118-.083-.288.063-.412.24-.3.428-.404.688-.735,1.398.554-.554.763-.741,1.062-1.169.125-.177.204-.386.085-.469Z",
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a8",
    "data-name": "a",
    d: "M19.371,7.391c-.111-.093-.292.037-.432.203-.336.4-.462.65-.854,1.329.6-.503.825-.672,1.16-1.072.14-.166.237-.367.126-.46Z",
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a9",
    "data-name": "a",
    d: "M19.808,7.792c-.102-.102-.295.012-.448.165-.369.369-.517.608-.966,1.249.642-.449.88-.597,1.249-.966.154-.154.267-.346.165-.448Z",
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a10",
    "data-name": "a",
    d: "M20.209,8.229c-.093-.111-.295-.014-.461.125-.4.336-.568.56-1.072,1.16.678-.392.929-.518,1.329-.854.167-.138.297-.32.204-.431Z",
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a11",
    "data-name": "a",
    d: "M20.57,8.7c-.083-.118-.292-.04-.47.085-.428.299-.615.509-1.169,1.062.71-.331.97-.435,1.398-.735.178-.124.324-.294.241-.412Z",
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a12",
    "data-name": "a",
    d: "M20.889,9.2c-.072-.125-.288-.065-.475.043-.452.261-.657.453-1.257.957.736-.268,1.005-.349,1.457-.61.187-.108.347-.265.275-.39Z",
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a13",
    "data-name": "a",
    d: "M21.163,9.726c-.061-.131-.281-.09-.477.002-.473.221-.694.394-1.335.843.757-.203,1.031-.26,1.504-.481.196-.091.369-.233.308-.364Z",
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a14",
    "data-name": "a",
    d: "M21.39,10.274c-.049-.136-.272-.114-.476-.04-.491.179-.725.332-1.404.724.771-.136,1.05-.169,1.541-.348.204-.074.388-.2.339-.336Z",
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a15",
    "data-name": "a",
    d: "M21.568,10.84c-.037-.14-.261-.137-.47-.081-.504.135-.752.268-1.462.599.78-.068,1.061-.077,1.565-.212.21-.057.405-.166.367-.306Z",
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a16",
    "data-name": "a",
    d: "M8.303,11.419c-.025.142.179.235.392.272.514.091.794.075,1.578.075-.736-.268-.994-.378-1.508-.469-.214-.037-.437-.02-.462.122Z",
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a17",
    "data-name": "a",
    d: "M8.432,10.84c-.037.14.158.249.367.305.504.135.785.144,1.565.212-.71-.331-.957-.464-1.462-.599-.209-.055-.433-.057-.47.082Z",
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a18",
    "data-name": "a",
    d: "M8.61,10.274c-.049.136.135.262.339.336.491.179.769.212,1.541.348-.678-.392-.913-.545-1.404-.724-.204-.074-.426-.096-.476.04Z",
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a19",
    "data-name": "a",
    d: "M8.837,9.726c-.061.131.112.273.308.364.473.221.748.278,1.504.481-.642-.449-.862-.623-1.335-.843-.196-.092-.416-.133-.477-.002Z",
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a20",
    "data-name": "a",
    d: "M9.111,9.2c-.072.125.088.282.275.39.452.261.721.342,1.457.61-.6-.503-.805-.695-1.257-.957-.187-.108-.403-.168-.475-.043Z",
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a21",
    "data-name": "a",
    d: "M9.43,8.7c-.083.118.063.288.24.412.428.299.688.404,1.398.735-.554-.554-.741-.763-1.169-1.062-.177-.125-.386-.204-.469-.085Z",
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a22",
    "data-name": "a",
    d: "M9.791,8.229c-.093.111.037.292.203.432.4.336.65.462,1.329.854-.504-.6-.672-.825-1.072-1.16-.166-.14-.367-.237-.46-.126Z",
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a23",
    "data-name": "a",
    d: "M10.192,7.792c-.102.102.012.295.165.448.369.369.608.517,1.249.966-.449-.642-.597-.88-.966-1.249-.154-.154-.346-.267-.448-.165Z",
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a24",
    "data-name": "a",
    d: "M10.629,7.391c-.111.093-.014.295.125.461.336.4.56.568,1.16,1.072-.392-.678-.518-.929-.854-1.329-.138-.167-.32-.297-.431-.204Z",
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a25",
    "data-name": "a",
    d: "M11.1,7.03c-.118.083-.04.292.085.47.3.428.509.615,1.062,1.169-.331-.71-.435-.97-.735-1.398-.124-.178-.294-.324-.412-.241Z",
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a26",
    "data-name": "a",
    d: "M11.6,6.711c-.125.072-.065.288.043.475.261.452.453.657.957,1.257-.268-.736-.349-1.005-.61-1.457-.108-.187-.265-.347-.39-.275Z",
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a27",
    "data-name": "a",
    d: "M12.126,6.437c-.131.061-.09.281.002.477.221.473.394.694.843,1.335-.203-.757-.26-1.031-.481-1.504-.091-.196-.233-.369-.364-.308Z",
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a28",
    "data-name": "a",
    d: "M12.674,6.21c-.136.049-.114.272-.04.476.179.491.332.725.724,1.404-.136-.771-.169-1.05-.348-1.541-.074-.204-.2-.388-.336-.339Z",
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a29",
    "data-name": "a",
    d: "M13.24,6.032c-.14.037-.137.261-.081.47.135.504.268.752.599,1.462-.068-.78-.077-1.061-.212-1.565-.057-.21-.166-.405-.306-.367Z",
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a30",
    "data-name": "a",
    d: "M13.819,5.903c-.142.025-.159.248-.122.461.091.514.201.772.469,1.508,0-.783.016-1.063-.075-1.578-.037-.212-.13-.416-.272-.391Z",
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a31",
    "data-name": "a",
    d: "M14.407,5.826c-.144.013-.18.233-.161.449.046.52.133.787.336,1.543.068-.78.108-1.058.063-1.578-.02-.216-.094-.427-.238-.414Z",
    style: {
      fill: "#ce1126"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,11.167h30v13.833H0v-13.833Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,11.667h30v13.333H0v-13.333Z",
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,18.333h30v6.667H0v-6.667Z",
    style: {
      fill: "#339e35"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMw);
export default __webpack_public_path__ + "static/media/MW.19b6b1ae17291e75d176c8326fd01d3b.svg";
export { ForwardRef as ReactComponent };